import { put } from 'redux-saga/effects'
import { displayErrorModal } from 'actions/application'
import strings from 'utils/strings'
import { HANDLED } from './constants'

/**
 * Forces mutation-style error feedback regardless of the HTTP method on the
 * error object.
 *
 * The default handler silently swallows failures for GET requests because GET
 * is treated as a read-only operation. Use this handler instead on `apiAction`
 * calls where the service uses GET (or another read method) for a mutating
 * operation — so that failures always surface a blocking error modal.
 *
 * Example: `changeUserRole` calls GET because the API endpoint cannot accept a
 * request body, but the operation is a mutation. Without this handler the
 * default GET-silent path would swallow the error and the user would have no
 * feedback that the role change failed.
 *
 * Place this as the sole entry in `errorHandlers` so it fires before
 * `defaultErrorHandler`:
 *
 *   apiAction({
 *     ...,
 *     errorHandlers: [mutationErrorHandler],
 *   })
 *
 * @returns {'handled'}
 */
// eslint-disable-next-line no-unused-vars
export default function* mutationErrorHandler(err, _context) {
  yield put(
    displayErrorModal(null, [
      strings.api_error_body_line1,
      strings.api_error_body_line2,
    ])
  )
  return HANDLED
}
